<template>
    <div>
        {{ $d(Date.parse(date), 'zCustomMonthYear') }} - <abbr title="Kalenderwoche">Kw.</abbr> {{ getCalendarWeekFromDate(date) }}
    </div>
</template>

<script>
import { DateTime } from 'luxon';

export default {
  name: 'delivery-installation-display',
  props: {
    date: Date
  },
  data () {
    return {
    }
  },
  methods: {
    /**
     * @returns {String} The week
     */
    getCalendarWeekFromDate(date) {
      return DateTime.fromJSDate(date).weekNumber;
    }
  }
}
</script>